import React from 'react'
import SharedSupplierSearch from './SharedSupplierSearch'
import UnauthedSearchResults from './UnauthedSearchResults'
import StatesContext from './StatesContext'
import PropTypes from 'prop-types'

function stateLookup (stateList) {
  return Object.fromEntries(stateList.map(state => [state.code, state.name]))
}

const UnauthedSupplierSearch = ({ stateList }) => {
  return (
    <div className='unauthed-supplier-search-container'>
      <StatesContext.Provider value={stateLookup(stateList)}>
        <SharedSupplierSearch
          placeholder='Search for a supplier by name'
          SearchResultsComponent={UnauthedSearchResults}
        />
      </StatesContext.Provider>
    </div>
  )
}

UnauthedSupplierSearch.propTypes = {
  stateList: PropTypes.array.isRequired
}

export default UnauthedSupplierSearch
